export const HomeRoutes = {
  Home: "/",
  About: "/about",
  Privacy: "/privacy",
  Terms: "/terms",
  Licenses: "/licenses",
} as const;
